const RugGuaranteesStatus = Object.freeze({
  OWN: 10,
  EXTERNAL: 20
})

module.exports = RugGuaranteesStatus
